import { render, staticRenderFns } from "./Service-Form-Template.vue?vue&type=template&id=e4b1cb7c"
import script from "./Service-Form-Template.vue?vue&type=script&lang=js"
export * from "./Service-Form-Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports